/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DriverEarningComparisonJobResponseDto1OfDriverEarningOpenTerminalRecoveryResultDtoAdmin } from '../models/DriverEarningComparisonJobResponseDto1OfDriverEarningOpenTerminalRecoveryResultDtoAdmin';
import type { DriverEarningComparisonJobResponseDto1OfNullable_1Admin } from '../models/DriverEarningComparisonJobResponseDto1OfNullable_1Admin';
import type { DriverEarningOpenTerminalRecoveryRequestAdmin } from '../models/DriverEarningOpenTerminalRecoveryRequestAdmin';
import type { DriverEarningOpenTerminalRecoverySummaryDtoAdmin } from '../models/DriverEarningOpenTerminalRecoverySummaryDtoAdmin';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DriverEarningsRecoveryService {
    /**
     * **Required Policy:** `ViewDriverEarning`
     * @returns DriverEarningOpenTerminalRecoverySummaryDtoAdmin OK
     * @throws ApiError
     */
    public static getOpenTerminalBatchesAsyncAdmin({
        regionIds,
        driverIds,
        batchIds,
        shipmentStatuses,
        terminalFromUtc,
        terminalToUtc,
        page,
        pageSize,
    }: {
        regionIds?: Array<number>,
        driverIds?: Array<number>,
        batchIds?: Array<string>,
        shipmentStatuses?: Array<number>,
        terminalFromUtc?: string,
        terminalToUtc?: string,
        page?: number,
        pageSize?: number,
    }): CancelablePromise<DriverEarningOpenTerminalRecoverySummaryDtoAdmin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/driver-earnings/recovery/open-terminal-batches',
            query: {
                'regionIds': regionIds,
                'driverIds': driverIds,
                'batchIds': batchIds,
                'shipmentStatuses': shipmentStatuses,
                'terminalFromUtc': terminalFromUtc,
                'terminalToUtc': terminalToUtc,
                'page': page,
                'pageSize': pageSize,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ReCalculateDriverEarnings`
     * @returns DriverEarningComparisonJobResponseDto1OfDriverEarningOpenTerminalRecoveryResultDtoAdmin OK
     * @throws ApiError
     */
    public static continueOpenTerminalBatchesAsyncAdmin({
        requestBody,
    }: {
        requestBody?: DriverEarningOpenTerminalRecoveryRequestAdmin,
    }): CancelablePromise<DriverEarningComparisonJobResponseDto1OfDriverEarningOpenTerminalRecoveryResultDtoAdmin> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/driver-earnings/recovery/open-terminal-batches/continue',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ReCalculateDriverEarnings`
     * @returns DriverEarningComparisonJobResponseDto1OfNullable_1Admin OK
     * @throws ApiError
     */
    public static getJobStateAsyncAdmin({
        requestKey,
    }: {
        requestKey: string,
    }): CancelablePromise<DriverEarningComparisonJobResponseDto1OfNullable_1Admin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/driver-earnings/recovery/jobs/{requestKey}',
            path: {
                'requestKey': requestKey,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
